import { render, staticRenderFns } from "./FormularioReciboConsignacion.vue?vue&type=template&id=26e11a72"
import script from "./FormularioReciboConsignacion.vue?vue&type=script&lang=js"
export * from "./FormularioReciboConsignacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports